/**
 * Utility functions - shorthand and logger functions.
*/

declare const URL_BASE: string;

import { reservaD, reservaT } from "./variables";

let popup_open = false; // Global var for popup open or not.

/** Get element by id alias */
function dId(id: string) { return document.getElementById(id); }
function dQS(s: string) { return document.querySelector(s); }
function dQSa(s: string) { return document.querySelectorAll(s); }

function showError(s: string) {
	showPopUp(s);
	logger("ERROR: " + s, "error");
}

function logger(s: string, type: string = "log"){

	return; 

	if (type == "log") {
		console.log(s);
		return;
	} else if (type == "warn") {
		console.warn(s);
		return;
	}else if (type == "error") {
		console.error(s);
		return;
	}
	
}

/** Hidden form for debug purposes */
function setHform() {

  logger("Debug var list");

  let debug = <any>[];

  for (let i = 0; i < reservaD.length; i++) {
    debug.push( [reservaT[i], reservaD[i]] );
  }

  console.table(debug);

}


/** Pop up window and close on key outside */

function showPopUp(str:string) {

	logger("** call popup", "log");
	
	var d = <HTMLElement>dId("actiondiv");
	d.className = "blackout";

	var ht = `<div class='popup-ficha'>
							<div class='inner-pop' id='httext'>${str}</div>
							<div class='cerrar' id="popup_close">
									<img src='${URL_BASE}img/close.svg' alt='cerrar' class='icon-alert'>
							</div>
						</div>`;

	d.innerHTML = ht;

	dId("popup_close")?.addEventListener("click", removePopUp);

	popup_open = true;

}


function removePopUp() {
	(<HTMLElement>dId("actiondiv")).innerHTML = "";
	(<HTMLElement>dId("actiondiv")).className = "";
}


// Pop up remover
document.onkeydown = function(evt) {

	evt = evt || window.event;
	if (evt.keyCode == 27) {
		removePopUp();
		popup_open = false;
	}

};

// Popup remover for click outside: 
window.addEventListener('click', function(e){
	
	// First time clicked to open popup, ignore click outside as this fires once content is loaded:
	if (popup_open) { 
		popup_open = false;
		return; 
	}


	if ( dId('popup_ficha_container') && e.target !== null) {	
		removePopUp();
		popup_open = false;
	}

});

// End of Global listeners.




// Allows for formatting Cents in a smaller font:
function beautifyPrice(n:string|number) {
	
	if (typeof n == "string") {
		n = parseFloat(n);
	}

	let p = n.toFixed(2).split(".");
	return p[0] + "<span class='cents'>," + p[1] + "€</span>";

}



export { showError, showPopUp, removePopUp, logger, dId, dQS, dQSa, setHform, beautifyPrice };